<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="menuList">
        <el-form :inline="true" :model="search" label-width="70px" class="demo-form-inline" size="small">
          <el-form-item label-width="100px">
            <el-input v-model="search.menuName" auto-complete="off" placeholder="请输入菜单名称"></el-input>
          </el-form-item>
          <el-form-item label-width="100px">
            <el-select v-model="search.menuType" size="small" placeholder="请选择菜单类型" clearable>
              <el-option label="web" value="web"></el-option>
              <el-option label="app" value="app"></el-option>
              <el-option label="pad" value="pad"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button id="menuListSearch" type="primary" @click="searchMenu()">查询</el-button>
            <el-button id="menuListAdd" type="primary" @click="handleAdd()">新增菜单</el-button>
          </el-form-item>
        </el-form>
      <div slot="content" class="menu-table-content">
        <el-table :data="tableDatas" style="width: 100%" height="calc(100% - 10px)" border>
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column prop="menuName" label="名称"></el-table-column>
          <el-table-column prop="menuType" label="类型" ></el-table-column>
          <el-table-column prop="menuSort" label="排序号" ></el-table-column>
          <el-table-column  prop="isPublic" label="是否公共菜单">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ !!scope.row.isPublic ? '是' : '否' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="350">
            <template slot-scope="scope">
              <el-button :id="scope.row.menuId" @click="handleClick(scope.row.menuId,scope.row.menuType)" size="mini">配置子菜单</el-button>
              <el-button :id="scope.row.menuId+'_edit'" @click="handleEdit(scope.row)" type="primary" size="mini" >编辑</el-button>
              <el-button :id="scope.row.menuId+'_delete'" @click="handleDelete(scope.row.menuId,scope.row.menuLevel)" type="danger" size="mini">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

    <!--编辑菜单-->
    <el-dialog title="修改菜单信息" :close-on-click-modal="false" :visible.sync="dialogFormVisible" @close="refresh">
      <el-form :model="selectTable" :rules="rules" ref="selectTable">
        <el-form-item label="菜单名称" prop="menuName" label-width="100px">
          <el-input id="selectTableMenuName" v-model="selectTable.menuName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item  label="菜单类型" prop="menuType" label-width="100px" v-if="selectTable.menuLevel!=2">
          <el-select id="selectTableMenuType" v-model="selectTable.menuType" size="small">
            <el-option label="请选择" value=""></el-option>
            <el-option label="web" value="web"></el-option>
            <el-option label="app" value="app"></el-option>
            <el-option label="pad" value="pad"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="菜单链接" prop="menuUrl" label-width="100px">
          <el-input id="selectTableMenuUrl" v-model="selectTable.menuUrl"></el-input>
        </el-form-item>
        <el-form-item label="是否公共" prop="isPublic" label-width="100px">
          <el-select id="selectTableIsPublic" v-model="selectTable.isPublic" size="small">
            <el-option label="请选择" value=""></el-option>
            <el-option label="公共" :value="1"></el-option>
            <el-option label="不公共" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="菜单排序号" prop="menuSort" label-width="100px">
          <el-input id="selectTableMenuSort" v-model="selectTable.menuSort"></el-input>
        </el-form-item>
        <el-form-item label="菜单描述" prop="menuDes" label-width="100px">
          <el-input id="selectTableMenuDes" v-model="selectTable.menuDes"></el-input>
        </el-form-item>
        <el-form-item label="菜单图标" prop="menuIcon" label-width="100px">
          <el-input id="selectTableMenuIcon" v-model="selectTable.menuIcon"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button id="selectTableClose" @click="dialogFormVisible = false">取 消</el-button>
        <el-button id="selectTableEdit" type="primary" @click="editSysMenu('selectTable')">确 定</el-button>
      </div>
    </el-dialog>

    <!--显示子菜单列表-->
    <el-dialog title="子菜单列表" :close-on-click-modal="false" :visible.sync="dialogTableVisible" width="60%" @close="cleanData">
      <el-button id="dialogAdd" @click="handleChildAdd()" type="primary" size="small">添加子菜单</el-button>
      <el-table :data="dictIDatas" v-loading="loading">
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column prop="menuName" label="名称"></el-table-column>
        <el-table-column prop="menuType" label="类型" ></el-table-column>
        <el-table-column prop="menuSort" label="排序号" ></el-table-column>
        <el-table-column prop="isPublic" label="是否公共菜单" >
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ !!scope.row.isPublic ? '是' : '否' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="230">
          <template slot-scope="scope">
            <el-button :id="scope.row.menuId+'_edit'" @click="handleEdit(scope.row)" type="primary" size="small" >编辑</el-button>
            <el-button :id="scope.row.menuId+'_delete'" @click="handleDelete(scope.row.menuId,scope.row.menuLevel)" type="danger" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!--添加菜单(1级，2级共用)-->
    <el-dialog title="添加菜单" :close-on-click-modal="false" :visible.sync="dialogAddFormVisible" @close="resetForm('ruleForm')">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="菜单名称" prop="menuName">
          <el-input id="ruleFormMenuName" v-model="ruleForm.menuName"></el-input>
        </el-form-item>
        <el-form-item label="菜单类型" prop="menuType" v-if="ruleForm.menuLevel!=2">
          <el-select id="ruleFormMenuType" v-model="ruleForm.menuType" size="small">
            <el-option label="请选择" value=""></el-option>
            <el-option label="web" value="web"></el-option>
            <el-option label="app" value="app"></el-option>
            <el-option label="pad" value="pad"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="菜单链接" prop="menuUrl">
          <el-input id="ruleFormMenuUrl" v-model="ruleForm.menuUrl"></el-input>
        </el-form-item>
        <el-form-item label="菜单排序号" prop="menuSort">
          <el-input id="ruleFormMenuSort" v-model="ruleForm.menuSort"></el-input>
        </el-form-item>
        <el-form-item label="是否公共" prop="isPublic">
          <el-select id="ruleFormIsPublic" v-model="ruleForm.isPublic" size="small">
            <el-option label="请选择" value=""></el-option>
            <el-option label="公共" :value="1"></el-option>
            <el-option label="不公共" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="菜单描述" prop="menuDes" >
          <el-input id="ruleFormMenuDes" type="textarea" v-model="ruleForm.menuDes"
                    maxlength="100" placeholder="100字以内"></el-input>
        </el-form-item>
        <el-form-item label="菜单图标" prop="menuIcon">
          <el-input id="ruleFormMenuIcon" v-model="ruleForm.menuIcon" maxlength="100" placeholder="100字以内"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button id="ruleFormSubmit" type="primary" @click="submitForm('ruleForm')">立刻添加</el-button>
          <el-button id="resetFormClose" @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: 'menuList',
  data () {
    var validateSort = (rule, value, callback) => {
      var str=/^\d+$/g;
      var flag = str.test(value);
      if (flag) {
        callback();
      } else {
        callback(new Error('输入值必须为大于等于0的整数'));
      }
    };
    return {
      tableDatas: [],
      dialogFormVisible: false,
      dialogTableVisible: false,
      dialogAddFormVisible: false,
      selectTable: {
        menuName:'',
        menuLevel:'',
        menuUrl:'',
        menuType:'',
        menuParentId:'',
        menuSort:'',
        isPublic:'',
        menuDes: '',
        menuIcon: ''
      },
      dictIDatas:[],
      loading:true,
      search: {
        menuName: '',
        menuType:'',
        facherId:'',
        facherType:'',
      },
      ruleForm: {
        menuName:'',
        menuLevel:'',
        menuUrl:'',
        menuType:'',
        menuParentId:'',
        menuSort:'',
        isPublic:'',
        menuDes: '',
        menuIcon: ''
      },
      rules: {
        menuName: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' },
          { max: 8, message: '长度在 8个字符以内', trigger: 'blur' }
        ],
        menuLevel: [
          { required: true, message: '请输入菜单等级', trigger: 'blur' },
          {type: 'number', message: '排序号必须为数字值'}
        ],
        menuUrl: [
          { required: true, message: '请输入菜单链接', trigger: 'blur' },
          { max: 50, message: '长度在 50个字符以内', trigger: 'blur' }
        ],
        menuType: [
          { required: true, message: '请选择菜单类型', trigger: 'blur' }
        ],
        menuSort: [
          { required: true, message: '请输入菜单排序号', trigger: 'blur' },
          {validator: validateSort}
        ],
        isPublic: [
          { required: true, message: '请输入菜单是否公开', trigger: 'blur' },
          {type: 'number', message: '排序号必须为数字值'}
        ],
        menuDes: [
          {  max: 100, message: '长度在 100 个字符以内', trigger: 'blur' }
        ],
        menuIcon: [
          {  max: 100, message: '长度在 100 个字符以内', trigger: 'blur' }
        ]
      }
    }
  },
  components:{
  },
  props: {},
  created() {

  },
  mounted() {
    this.findSysMenuList();
  },

  methods: {
    //查询所有的菜单（区分web,app,pad），按照升序排列
    findSysMenuList(){
      var _this = this;
      _this.$post('sys/findSysMenuList',{
        menuType: '',
        menuParentId:''
      }).then(function(response){
        if (response.code == '1'){
          _this.tableDatas = response.result.sysMenuList;
        }
      }).catch(function (error) {

      })
    },

    //菜单搜索
    searchMenu(){
      var _this = this;
      _this.$post('sys/findSysMenuList',{
        menuName: _this.search.menuName,
        menuType: _this.search.menuType
      }).then(function (response) {
        if (response.code == '1') {
          _this.tableDatas = response.result.sysMenuList;
        }
      }).catch(function (error) {

      })
    },

    //查看子菜单列表
    handleClick(facherRow,facherTypeRow){
      var _this = this;
      _this.facherId = facherRow;
      _this.facherType = facherTypeRow;
      _this.dialogTableVisible = true;
      _this.$post('sys/findSysMenuList',{
        menuType: '',
        menuParentId:_this.facherId,
      }).then(function(response){
        if (response.code == '1'){
          _this.loading = false;
          _this.dictIDatas = response.result.sysMenuList;
        }
      }).catch(function (error) {

      })
    },

    //清空数据
    cleanData(){
      this.dictIDatas = [];
      //this.selectTable = {};
      this.searchMenu();
      //this.findSysMenuList();

    },

    //新增菜单弹窗
    handleAdd() {
      this.dialogAddFormVisible = true;
      this.ruleForm.menuLevel = 1;
      this.facherId='';
      this.facherType='';
    },

    //新增子菜单弹窗
    handleChildAdd() {
      this.dialogAddFormVisible = true;
      this.ruleForm.menuParentId = this.facherId;
      this.ruleForm.menuLevel = 2;
      this.ruleForm.menuType = this.facherType;
    },

    //清空新增菜单的数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    //验证表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addSysMenu();
        } else {
          return false;
        }
      });
    },

    //新增菜单
    addSysMenu(){
      var _this = this;
      _this.$post('sys/addSysMenu',{
        menuLevel: _this.ruleForm.menuLevel,
        menuUrl: _this.ruleForm.menuUrl,
        isPublic: _this.ruleForm.isPublic,
        menuType: _this.ruleForm.menuType,
        menuParentId: _this.ruleForm.menuParentId ||'',
        menuName: _this.ruleForm.menuName,
        menuSort: _this.ruleForm.menuSort,
        menuDes: _this.ruleForm.menuDes,
        menuIcon: _this.ruleForm.menuIcon,
        urlType: 0
      }).then(function (response) {
        if (response.code == '1') {
          _this.$message({
            type: 'success',
            message:  '添加菜单成功'
          });
          if(_this.ruleForm.menuLevel==1){
            //_this.findSysMenuList();//菜单列表
            _this.searchMenu();
          }else{
            _this.handleClick(_this.ruleForm.menuParentId,_this.ruleForm.menuType);//子菜单
          }
          _this.dialogAddFormVisible = false;
        }else{
          _this.$message({
            type: 'error',
            message: response.msg
          });
        }
      }).catch(function (error) {

      })
    },

    //编辑菜单窗口
    handleEdit(row) {
      this.selectTable.menuId = row.menuId
      this.selectTable.menuUrl = row.menuUrl
      this.selectTable.menuName = row.menuName,
      this.selectTable.menuLevel = row.menuLevel,
      this.selectTable.menuType = row.menuType,
      this.selectTable.menuParentId = row.menuParentId,
      this.selectTable.menuSort = row.menuSort,
      this.selectTable.isPublic = row.isPublic,
      this.selectTable.menuDes = row.menuDes,
      this.selectTable.menuIcon = row.menuIcon,
      this.dialogFormVisible = true;
    },

    //校验编辑菜单
    editSysMenu(selectTable){
      var _this = this;
      _this.$refs[selectTable].validate((valid) => {
        //debugger;
        if (valid) {
          _this.editSysMenuSubmit();
        } else {
          return false;
        }
      });
    },

    //提交编辑菜单
    editSysMenuSubmit(){
      var _this = this;
      //debugger;
      _this.$post('sys/editSysMenu',{
        menuId: _this.selectTable.menuId,
        menuLevel: _this.selectTable.menuLevel,
        menuUrl: _this.selectTable.menuUrl,
        menuType: _this.selectTable.menuType,
        menuParentId: _this.selectTable.menuParentId ||'',
        menuName: _this.selectTable.menuName,
        isPublic: _this.selectTable.isPublic,
        menuSort: _this.selectTable.menuSort,
        menuDes: _this.selectTable.menuDes,
        menuIcon: _this.selectTable.menuIcon

      }).then(function (response) {
        if (response.code == '1') {
          _this.$message({
            type: 'success',
            message: '更新信息成功'
          });
          _this.dialogFormVisible = false;
          //_this.findSysMenuList();//查询菜单列表
          if(_this.selectTable.menuLevel==1){
            //_this.findSysMenuList();//菜单列表
            _this.searchMenu();
          }else{
            _this.handleClick(_this.selectTable.menuParentId,_this.selectTable.menuType);//子菜单
          }
        }else{
          _this.$message({
            type: 'error',
            message: response.msg
          });
        }
      }).catch(function (error) {

      })
    },

    //日期处理
    dateFormat(row, column){
      var date = row[column.property];
      return this.timestampToTime(date);
    },

    //编辑框关闭跳转
    refresh(){
      //this.findSysMenuList();
      this.searchMenu();
    },

    //删除菜单
    handleDelete(menuId,menuLevel){
      var _this = this;
      _this.$confirm('此操作将删除该菜单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$post('sys/deleteSysMenu',{"menuId":menuId}).then(function(response){
          if(response.code == '1'){
            if(menuLevel==1){
              _this.searchMenu();//菜单列表(带条件刷新)
            }else{
              _this.handleClick(_this.facherId ,_this.facherType);//子菜单
            }
            _this.$message({
              type: 'success',
              showClose: true,
              message: '删除成功!',
              duration:1000
            });
          }
        });
      }).catch(() => {
        _this.$message({
          type: 'info',
          showClose: true,
          message: '已取消删除'
        });
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.menuList{
		height: 100%;
	}
	.menu-table-content{
		height: calc(100% - 50px);
	}
</style>
